export default function Features() {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'No-Log Policy',
      description: 'We never track, collect, or share your private data. Your privacy is our priority.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Works on desktop, mobile, and tablets.'
    },
    {
      icon: 'ri-time-line',
      title: '24/7 Protection',
      description: 'Round-the-clock security that never sleeps. Stay protected at all times.'
    },
    {
      icon: 'ri-wifi-line',
      title: 'Public WiFi Security',
      description: 'Stay safe on public networks. Encrypt your connection wherever you go.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Anonymous Browsing',
      description: 'Hide your IP address and browse the internet completely anonymously.'
    },
    {
      icon: 'ri-download-cloud-line',
      title: 'Unlimited Bandwidth',
      description: 'No restrictions on data usage. Stream, download, and browse without limits.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-start">
          <div className="md:col-span-2">
            <span className="text-purple-600 font-semibold text-sm uppercase tracking-wider">
              FEATURES
            </span>
            <h2 className="text-5xl font-bold text-gray-900 mt-4 mb-6 leading-tight">
              Everything You Need
              <br />
              <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                For Complete
              </span>
              <br />
              Protection
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              Our VPN service comes packed with powerful features designed to keep you safe, secure, and anonymous online.
            </p>
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  const offset = 80;
                  const elementPosition = element.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - offset;
                  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                }
              }}
              className="text-purple-600 font-semibold hover:text-purple-700 transition-colors cursor-pointer inline-flex items-center whitespace-nowrap"
            >
              Get Started Today
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>

          <div className="md:col-span-3">
            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-gray-50 rounded-xl p-6 hover:bg-gradient-to-br hover:from-blue-50 hover:to-purple-50 transition-all duration-300 cursor-pointer group"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${feature.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
